import { useRenewalOverview } from "src/renewal/interfaces/Renwals"
import { useDennemeyer } from "../DennemeyerProvider"
import { PureMemberRenwalsEdit } from "../import/ImportModal"

export function ImportRenewalMember() {
  const {member} = useRenewalOverview()
  const {ipRightByMemberId, fallbackOwnerId} = useDennemeyer()

  const pcIpRight = ipRightByMemberId[member?.familyMemberId]

  return <PureMemberRenwalsEdit {...{member, pcIpRight, fallbackOwnerId}} />
}